export default {
  back: {
    id: 'bo_seller-options-batch_listing_creation-back',
    defaultMessage: 'Back to Batch Listing Creation',
  },
}
